// in ms
export const slowApiTimeThreshold = 3000;
export const ssrApiDefaultTimeout = 9000;
export const apiHosts = {
    browse: 'browse',
    search: 'search',
    content: 'content',
    coupon: 'coupon',
    order: 'order',
    account: 'account',
    delphi: 'delphi',
    impulse: 'impulse',
    elb: 'elb',
    appHost: 'appHost', // There are API that uses relative hostname to call API. E.g. m.jcpenney.com/v5/j/home and www.jcpeney.com/v5/j/home
    caseMgmt: 'caseMgmt',
    posf: 'posf',
    customerapi: 'customerapi',
    contentarticles: 'contentarticles',
    promise: 'promise',
    jetlore: 'jetlore',
    abtest: 'abtest',
    pricing: 'pricing',
    l2categoryapi: 'l2categoryapi',
};
